import { combineReducers, createStore } from "redux";
import * as reducers from ".";

const rootReducer = combineReducers({
  ...reducers,
});

const initStore = (initialState = {}) => createStore(rootReducer, initialState);

export default initStore;



// WEBPACK FOOTER //
// ./src/state/store.js